import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

@Injectable({
  providedIn: 'any',
})
export class QueryNaturesContratContratGQLService extends Query<Response> {
  document = gql`
    query ReferentielNaturesContrats {
      referentielNaturesContrats {
        code
        libelle
      }
    }
  `;
}
